import { $getReferenceCitationNodes } from './getReferenceCitationNodes';

export function $replaceReferenceCitationId(
  referenceId: string,
  newReferenceCitationId: string,
): void {
  $getReferenceCitationNodes().forEach((node) => {
    if (node.getReferenceId() === referenceId) {
      node.setReferenceId(newReferenceCitationId);
    }
  });
}
